import type { CSSProperties } from 'react'

// Classic's custom select chevron (#679). It used to be stroked in MCL's gold
// (#FFD700) for every league; it now uses the select's own muted white, and
// the selects reserve room for it (pr-9/pr-10) so long options never run
// under it.
export const CLASSIC_SELECT_CHEVRON: CSSProperties = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23ffffff' stroke-opacity='0.6'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
  backgroundSize: '16px',
}
